// extracted by mini-css-extract-plugin
export default {"stores":"ruKiT","stores-title":"Q3NE4"};